export default import.meta.ROLLDOWN_FILE_URL_TsX43dW8OnkpgnqP83IRHw